import { useState, useEffect } from 'react';
import { api } from '../api';
// [F-CANDTRACK] A követő token hitelesítő adat, ezért SZÁNDÉKOSAN NEM a marketing
// TrackingContext-ben él: külön sessionStorage kulcson tároljuk, és az URL-ből
// beolvasás után azonnal eltávolítjuk (referrer / history / megosztott link leak).
// A levél-gomb FRAGMENT formát küld (#application_token=...) — az a szerverhez el
// sem jut; a query forma kézi linkekhez kompat marad. A career.tpl korai head-scriptje
// (analytics ELŐTT) már kiemelhette a tokent a window.__CAREER_APPLICATION_TOKEN__-be.
const STORAGE_KEY = 'career_apply_status_v1';
const TOKEN_RE = /^[a-f0-9]{32}$/;
function storeToken(token) {
    try {
        sessionStorage.setItem(STORAGE_KEY, token);
    }
    catch (e) {
        // private mode / storage tiltva — a token így csak erre a betöltésre él
    }
}
export function readApplicationToken() {
    if (typeof window === 'undefined')
        return '';
    try {
        // 1) a korai head-script memória-átadása (storage-hiba esetén is megvan);
        //    átvétel után töröljük — a token ne éljen tovább globális változóban
        const w = window;
        if (typeof w.__CAREER_APPLICATION_TOKEN__ === 'string' && TOKEN_RE.test(w.__CAREER_APPLICATION_TOKEN__)) {
            const memToken = w.__CAREER_APPLICATION_TOKEN__;
            try {
                delete w.__CAREER_APPLICATION_TOKEN__;
            }
            catch (e) {
                w.__CAREER_APPLICATION_TOKEN__ = '';
            }
            storeToken(memToken);
            return memToken;
        }
        // 2) URL-beli token: fragment (a levél-gomb formátuma — a szerverhez el sem jut)
        //    prioritással a query előtt; a tisztítás MINDKÉT helyről töröl, a többi
        //    hash-szegmens és query-paraméter érintetlen marad
        let token = '';
        const hashBody = (window.location.hash || '').replace(/^#/, '');
        const keptSegments = [];
        for (const segment of (hashBody ? hashBody.split('&') : [])) {
            const m = segment.match(/^application_token=([a-f0-9]{32})$/);
            if (m) {
                if (!token)
                    token = m[1];
            }
            else if (segment !== '') {
                keptSegments.push(segment);
            }
        }
        const newHash = keptSegments.length ? `#${keptSegments.join('&')}` : '';
        const sp = new URLSearchParams(window.location.search);
        const queryToken = sp.get('application_token') || '';
        if (!token && TOKEN_RE.test(queryToken)) {
            token = queryToken;
        }
        sp.delete('application_token');
        const qs = sp.toString();
        if (token) {
            storeToken(token);
            const cleanUrl = window.location.pathname + (qs ? `?${qs}` : '') + newHash;
            if (cleanUrl !== window.location.pathname + window.location.search + window.location.hash) {
                try {
                    window.history.replaceState(null, '', cleanUrl);
                }
                catch (e) {
                    // ha a replaceState nem elérhető, a token az URL-ben marad — degradált, de működő
                }
            }
            return token;
        }
        // 3) korábbi betöltés sessionStorage-e
        const stored = sessionStorage.getItem(STORAGE_KEY) || '';
        return TOKEN_RE.test(stored) ? stored : '';
    }
    catch (e) {
        return '';
    }
}
// A timeline adat lekérése: csak akkor fut, ha van érvényes formátumú token ÉS
// betöltött job. Bármilyen hiba / found:false esetén null marad — a blokk
// egyszerűen nem jelenik meg (a hiba a jelöltnek nem érdekes).
export function useApplicationStatus(jobId) {
    const [token] = useState(() => readApplicationToken());
    const [status, setStatus] = useState(null);
    useEffect(() => {
        if (!token || !jobId) {
            setStatus(null);
            return;
        }
        let cancelled = false;
        api.applicationStatus(jobId, token)
            .then(res => {
            if (!cancelled && res && res.found)
                setStatus(res);
        })
            .catch(() => {
            // csendes: hálózati/szerver hibánál nincs timeline
        });
        return () => {
            cancelled = true;
        };
    }, [token, jobId]);
    return status;
}
